//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreReturnCommand: any = {
    GetMusteriİade: Backofficebff + '/v1/storereturn/musteri-iade',
    GetCustomerDecision: Backofficebff + '/v1/storereturn/customer-return-decision',
};
